import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useField, useFormikContext } from "formik";
import { at } from "lodash";

export default function DatePicker(props: any) {
  const { disabled, errorText, ...rest } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const handleChange = (newValue: any) => {
    setFieldValue(field.name, newValue);
  };

  const renderHelpText = () => {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return error;
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={3}>
        <DesktopDatePicker
          inputFormat="dd/MM/yyyy"
          value={field.value}
          onChange={handleChange}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                {...rest}
                InputLabelProps={{ shrink: true }}
                disabled={disabled}
                error={meta.touched && meta.error && true}
                helperText={renderHelpText()}
              />
            );
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
